import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
const checklist = ['Objetivo pedagógico y espiritual claro', 'Versículo principal con contexto', 'Pregunta disparadora para iniciar la conversación', 'Dinámica de participación lista para usar', 'Actividad práctica paso a paso', 'Oración final para cerrar el encuentro'];
const temas = [{
  emoji: '🤍',
  text: 'Dios me conoce y me ama'
}, {
  emoji: '👫',
  text: 'Jesús es mi amigo'
}, {
  emoji: '🙏',
  text: 'Aprendo a rezar'
}, {
  emoji: '🌟',
  text: 'La importancia de agradecer'
}, {
  emoji: '🤝',
  text: 'Ayudar a los demás'
}, {
  emoji: '💛',
  text: 'Aprender a perdonar'
}, {
  emoji: '🕊️',
  text: 'Confiar en Dios cuando tengo miedo'
}, {
  emoji: '💡',
  text: 'Ser una luz para otros'
}, {
  emoji: '🌿',
  text: 'Cuidar la creación'
}, {
  emoji: '✝️',
  text: 'Mi misión como cristiano'
}];
export function ProPack() {
  return <section className="py-10 md:py-20 px-4 md:px-6 bg-cream-100" data-id="element-197">
      <div className="max-w-5xl mx-auto" data-id="element-198">
        <div className="text-center mb-8 md:mb-12" data-id="element-199">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy-900 mb-2 md:mb-4" data-id="element-200">
            ¿Qué agrega el Pack PRO?
          </h2>
          <p className="text-base md:text-xl text-navy-900/70 max-w-2xl mx-auto" data-id="element-201">
            Para catequistas que quieren llegar al encuentro con todo listo —
            sin pensar, sin improvisar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gold-500/20" data-id="element-202">
          <div className="bg-navy-950 p-6 md:p-8 text-center border-b border-gold-500/30" data-id="element-203">
            <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-gold-500/20 mb-3 md:mb-4" data-id="element-204">
              <Star className="w-6 h-6 md:w-8 md:h-8 text-gold-500 fill-gold-500" data-id="element-205" />
            </div>
            <h3 className="text-xl md:text-2xl lg:text-3xl font-serif font-bold text-cream-50 px-2" data-id="element-206">
              Tomo Exclusivo — 10 Planificaciones Completas para Catequesis
              Infantil
            </h3>
          </div>

          <div className="p-5 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-207">
            <div data-id="element-208">
              <h4 className="text-lg md:text-xl font-bold text-navy-900 mb-4 md:mb-6 border-b border-cream-200 pb-3 md:pb-4" data-id="element-209">
                Cada encuentro incluye:
              </h4>
              <ul className="space-y-3 md:space-y-4" data-id="element-210">
                {checklist.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-211">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold-500 shrink-0" data-id="element-212" />
                    <span className="text-sm md:text-base text-navy-900/80 font-medium" data-id="element-213">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-214">
              <h4 className="text-lg md:text-xl font-bold text-navy-900 mb-4 md:mb-6 border-b border-cream-200 pb-3 md:pb-4" data-id="element-215">
                Los 10 temas incluidos:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3" data-id="element-216">
                {temas.map((tema, i) => <motion.div key={i} whileHover={{
                scale: 1.03,
                borderColor: '#c8a24a'
              }} className="bg-cream-50 p-2 md:p-3 rounded-lg border border-cream-200 flex items-center gap-2 md:gap-3 cursor-default" data-id="element-217">
                    <span className="text-lg md:text-xl" data-id="element-218">{tema.emoji}</span>
                    <span className="text-xs md:text-sm font-medium text-navy-900/80 leading-tight" data-id="element-219">
                      {tema.text}
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}